module.exports = __webpack_public_path__ + "media/images/proof_links/colored/instagram-c9b542c91e8ef706f135ea9aea3a7fe1.svg";